module.exports = __webpack_public_path__ + "img/sleeping-bot-avatar.b878302d.png";